/**
 * Asynchronously loads the component for managing documents
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
